"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Chevron = _interopRequireDefault(require("./Chevron"));

function Accordion(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      setActive = _useState2[0],
      setActiveState = _useState2[1];

  var _useState3 = (0, _react.useState)("0px"),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      setHeight = _useState4[0],
      setHeightState = _useState4[1];

  var _useState5 = (0, _react.useState)("accordion__icon"),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      setRotate = _useState6[0],
      setRotateState = _useState6[1];

  var content = (0, _react.useRef)(null);

  function toggleAccordion() {
    setActiveState(setActive === "" ? "active" : "");
    setHeightState(setActive === "active" ? "0px" : "".concat(content.current.scrollHeight, "px"));
    setRotateState(setActive === "active" ? "accordion__icon" : "accordion__icon rotate");
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "accordion__section"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "accordion ".concat(setActive),
      onClick: toggleAccordion
    },
    /*#__PURE__*/
    _react["default"].createElement("p", {
      className: "accordion__title"
    }, props.title),
    /*#__PURE__*/
    _react["default"].createElement(_Chevron["default"], {
      className: "".concat(setRotate),
      width: 10,
      fill: "#777"
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      ref: content,
      style: {
        maxHeight: "".concat(setHeight)
      },
      className: "accordion__content"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "accordion__text",
      dangerouslySetInnerHTML: {
        __html: props.content
      }
    })))
  );
}

var _default = Accordion;
exports["default"] = _default;